module.exports = __webpack_public_path__ + "static/img/gif_404.6b8ae1d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif_404.gif
// module id = 6ccA
// module chunks = 34